export function showDiv(div) {
    document.getElementById(div).style.display = 'block';
}

export function closeDiv(div) {
    document.getElementById(div).style.display = 'none';
}